import { TireQuoteRecordCustomer } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';

interface Props {
  tireOffer: TireQuoteRecordCustomer;
  addressId: number | undefined;
}

/** Whether the offer's mounting services reach the address; idle until there is one. */
export const useTireOfferDeliveryCheck = ({ tireOffer, addressId }: Props) => {
  const { currentBrand } = useCurrentBrand();
  return noddiAsync.useGet({
    type: URLKeys.getSalesItemsDeliveryCheck,
    input: {
      addressId: addressId as number,
      brandDomain: currentBrand,
      salesItemsIds: tireOffer.genericItems.map((item) => item.id)
    },
    queryConfig: {
      enabled: addressId !== undefined
    }
  });
};
